import { render, staticRenderFns } from "./VersionTable.vue?vue&type=template&id=10addff0&"
import script from "./VersionTable.vue?vue&type=script&lang=ts&"
export * from "./VersionTable.vue?vue&type=script&lang=ts&"
import style0 from "./VersionTable.vue?vue&type=style&index=0&id=10addff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports